// extracted by mini-css-extract-plugin
export default {"iconRight":"Collapse_iconRight__4Dgju","standaloneIcon":"Collapse_standaloneIcon__mXQpe"};